import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ThemeButton from '../ThemeButton';

const NO_POLICIES_TEXT = `
<p><strong>Informação importante sobre as políticas desta reserva</strong></p>
<br/>
<p>O fornecedor ainda não disponibilizou as políticas completas de reserva, cancelamento e reembolso no momento desta cotação.</p>
<br/>
<p>Para mais detalhes ou dúvidas específicas sobre esta reserva, entre em contato com nosso atendimento:</p>
<ul>
  <li><strong>WhatsApp:</strong> <a href="https://wa.me/5511992331243" target="_blank" rel="noreferrer">Conversar com (11) 99233-1243</a></li>
  <li><strong>E-mail:</strong> <a href="mailto:faleconosco@destinoferias.com.br">faleconosco@destinoferias.com.br</a></li>
</ul>
<br/>
<p>Nossa equipe terá prazer em te ajudar com todas as informações necessárias antes de você finalizar a reserva.</p>
`;

const buildPoliciesHtml = (policies, cancellationPolicies) => {
	let html = '';

	if (policies && policies.length > 0) {
		policies.forEach((policy) => {
			if (policy.name || policy.description) {
				html += `<div style="margin-bottom: 16px;">`;
				if (policy.name) html += `<p><strong>${policy.name}</strong></p>`;
				if (policy.description) html += `<p style="margin-top: 4px; white-space: pre-line;">${policy.description}</p>`;
				html += `</div>`;
			}
		});
	}

	if (cancellationPolicies) {
		html += `<div style="margin-bottom: 16px; margin-top: 16px; border-top: 1px solid #eee; padding-top: 16px;">`;
		html += `<p><strong>Política de Cancelamento</strong></p>`;
		html += `<p style="margin-top: 4px;">Reembolsável: ${cancellationPolicies.refundable ? 'Sim' : 'Não'}</p>`;
		if (cancellationPolicies.penalties && cancellationPolicies.penalties.length > 0) {
			cancellationPolicies.penalties.forEach((penalty) => {
				if (penalty.name || penalty.description) {
					html += `<div style="margin-top: 8px;">`;
					if (penalty.name) html += `<p><strong>${penalty.name}</strong></p>`;
					if (penalty.description) html += `<p>${penalty.description}</p>`;
					html += `</div>`;
				}
			});
		}
		html += `</div>`;
	}

	return html || NO_POLICIES_TEXT;
};

const formatBRL = (value) =>
	Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export default function CarPoliciesModal({ opened, policies, cancellationPolicies, priceUpdate, onAccept, onDecline }) {
	const [bottom, setBottom] = React.useState(false);
	const [contentArea, setContentArea] = React.useState(null);

	const text = buildPoliciesHtml(policies, cancellationPolicies);

	const handleScroll = (e) => {
		const threshold = 5;
		const isAtBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight <= threshold;
		setBottom(isAtBottom);
	};

	React.useEffect(() => {
		if (contentArea) {
			if (contentArea.scrollHeight <= contentArea.clientHeight) {
				setBottom(true);
				return;
			}
			const isAtBottom = contentArea.scrollHeight - contentArea.scrollTop - contentArea.clientHeight <= 5;
			setBottom(isAtBottom);
		}
	}, [contentArea]);

	return (
		<Dialog open={opened} aria-labelledby="car-policies-title" maxWidth="sm" fullWidth>
			<DialogTitle id="car-policies-title">Políticas da Reserva</DialogTitle>
			{priceUpdate && (
				// Fica fora do DialogContent de proposito: o botao de aceite so
				// habilita apos rolar as politicas ate o fim, e la embaixo um
				// aviso dentro da area rolavel ja teria saido de vista.
				<div
					style={{
						margin: '0 24px 8px',
						padding: 12,
						borderRadius: 4,
						border: '1px solid #f0c36d',
						background: '#fdf6e3',
					}}
				>
					<p style={{ fontWeight: 'bold', marginBottom: 4 }}>
						O valor desta reserva foi atualizado
					</p>
					<p>
						O fornecedor atualizou a tarifa de {formatBRL(priceUpdate.from)}{' '}
						para <strong>{formatBRL(priceUpdate.to)}</strong>. O resumo e as
						formas de pagamento já refletem o novo valor.
					</p>
				</div>
			)}
			<DialogContent
				sx={{ overflow: 'scroll' }}
				onScroll={handleScroll}
				ref={(el) => setContentArea(el)}
			>
				<DialogContentText
					id="car-policies-description"
					dangerouslySetInnerHTML={{ __html: text }}
				/>
			</DialogContent>
			<DialogActions>
				<ThemeButton className="payment secondary" onClick={onDecline}>
					Recusar
				</ThemeButton>
				<ThemeButton
					className="payment"
					onClick={onAccept}
					disabled={!bottom}
				>
					Li e aceito as políticas
				</ThemeButton>
			</DialogActions>
		</Dialog>
	);
}
